import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";
import Wnd_Ok from "../../../lib/ui/wnd_ok";

class Tbv_Tbs extends React.Component {
  constructor(props, context) {
    super(props);

    this.store = props.store;
    this.state = {};
    this.state.rsa = [];
    this.state.tba = [];
    this.state.msg = {};
    this.state.cols = {};
    this.state.rs = props.rs;
   }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      this.tbs();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    tab_style(tabid) {
      var css = {};
      css.display = "none";
      if(this.state.tabval === tabid) css.display = "block";
      return css;
    }
    bq_close() {
		this.props.ctx.setState({ wnds: {} });
	};
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
  cssCols (cid) {
      var css = {};
      if(this.state.cols[cid]) css.width = this.state.cols[cid].toString() + "px";
      //if(cid == "c01") alert(JSON.stringify(this.state.cols[cid]));
      return css;
  }
  syncCols (tb) {

    if (!document.getElementById(tb)) return;

    var cols = {};
    var ix = document.getElementById(tb).rows.length - 1;
    var ic = document.getElementById(tb).rows[0].cells.length;
    var ci = 0;
    while(ci < ic) {
        var cxi = ci + 1;
        var col = "c" + cxi.toString().padStart(2, "0");
        cols[col] = document.getElementById(tb).rows[ix].cells[ci].clientWidth + 1;
        ci = ci + 1;
    }
    this.setState({cols: cols });
    //alert(JSON.stringify(this.state.cols));
    //this.forceUpdate();
  };
  tbs() {
    var self = this;
    var prm = {};
    prm.req = "pms.rs_lt.lt_tbs";
    prm.rs = this.state.rs;
    //prm.fplu = datum;
    //prm.tplu = datum;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        var o = {};
        //o.deps = ret.rco;
        //alert(JSON.stringify(o));
        var a = [];
        var keys = Object.keys( ret.rco );
        for(var key of keys) {
            var tbo = ret.rco[key];
            //alert(JSON.stringify(tbo));
            a.push( tbo );
        }
        //self.setState({tba: ret.rco });
        self.setState({tba: a });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
  prn(event) {
  }

  render() {
    if(!this.props.wnds.tbs) return "";

    var title = this.props.title;
    if(!title) title = "Titel";

	var html =
        <div className="mx_base">
        { this.props.wnds.backdrop ? <div className="mx_backdrop" /> : null }
        <div className="mx_dlg mx_90 flex-col" style={ this.dlg_style() }>
        <div className="mx_content flex">

            <div className="flex-row" style={{padding:"5px",height:"35px"}}>
                    <div className="flex-col flex">
                        <div>Bord</div>
                    </div>
                    <div className="flex-col">
                        <div>UPPDATERA</div>
                    </div>
            </div>
            <div className="divider_orange"></div>

        <div className="web-row px-2">
            <table className="table table-bordered table-hover tb fixed_header">
                <thead>
                <tr>
                <th style={ this.cssCols("c01" ) }>Bordsnr</th>
                <th style={ this.cssCols("c02" ) }>Typ</th>
                <th style={ this.cssCols("c03" ) }>Sort</th>
                <th style={ this.cssCols("c04" ) }>Platser</th>
                <th style={ this.cssCols("c05" ) }>Från</th>
                <th style={ this.cssCols("c06" ) }>Till</th>
                <th style={ this.cssCols("c07" ) }>ID</th>
                <th style={ this.cssCols("c08" ) }>Reservationstid</th>
                <th style={ this.cssCols("c09" ) }>Zon</th>
                <th style={ this.cssCols("c10" ) }>Uppdaterad</th>
                <th style={ this.cssCols("c11" ) }></th>
                    <th>Tid</th>
                </tr>
                </thead>
                <tbody style={ this.tb_style() }>
                { this.state.tba.map((row, key) =>
                <tr key={key} onDoubleClick={() => this.tb_edit(row) }>
                    <td>{ row.bordsnr }</td>
                    <td>{ row.bordsname }</td>
                    <td>{ row.bordX }</td>
                    <td>{ row.bordY }</td>
                    <td>{ row.bordXlen }</td>
                    <td>{ row.bordYlen }</td>
                    <td>{ row.iresurs }</td>
                    <td>{ row.reservtime }</td>
                    <td>{ row.zon }</td>
                    <td>{ row.upddat }</td>
                </tr>
                )}
                </tbody>
            </table>
        </div>

        </div>

        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.bq_close() } >
                STÄNG
            </button>
            <div className="flex-row">
            </div>
            <button className="btn btn-hw-green w250 hide" onClick={(event) => this.prn(event) } >
                SKRIV UT
            </button>
        </div>
      </div>
        <Wnd_Ok msg={this.state.msg} ctx={this} />
    </div>
	;
	return html;
  };
}

export default Tbv_Tbs;